"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XGLinksHK = exports.XGLinkGBHK = exports.AHXGLinkGB = exports.XGLinkGB = exports.XGLinkJJ = exports.XGLinkZX = exports.XGLinkGBZX = exports.XGLinkAStock = exports.XGLinks = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 * 股票相关链接
 * @returns
 */
function XGLinks(props) {
    var market = props.quotecode.substring(0, props.quotecode.indexOf('.'));
    var code = props.quotecode.substring(props.quotecode.indexOf('.') + 1);
    return (react_1.default.createElement("div", { className: "xglinks" },
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(code, ".html") }, "\u80A1\u5427"),
        react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/".concat(code, ".html") }, "\u8D44\u91D1\u6D41"),
        props.xgtype == 'bk_hy' &&
            react_1.default.createElement("a", { href: "//data.eastmoney.com/report/".concat(code.replace('BK', ''), "yb.html") }, "\u7814\u62A5")));
}
exports.XGLinks = XGLinks;
/**
 * 相关链接：股吧-资金流-数据
 */
function XGLinkAStock(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(props.code, ".html") }, "\u80A1\u5427"),
        "\u00A0",
        react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/".concat(props.code, ".html") }, "\u8D44\u91D1\u6D41"),
        "\u00A0",
        react_1.default.createElement("a", { href: "//data.eastmoney.com/stockdata/".concat(props.code, ".html") }, "\u6570\u636E")));
}
exports.XGLinkAStock = XGLinkAStock;
/**
 * 相关链接：股吧-资讯
 * @param props
 * @returns
 */
function XGLinkGBZX(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(props.code, ".html") }, "\u80A1\u5427"),
        "\u00A0",
        react_1.default.createElement("a", { href: "//so.eastmoney.com/Web/s?keyword=".concat(encodeURIComponent(props.name)) }, "\u8D44\u8BAF")));
}
exports.XGLinkGBZX = XGLinkGBZX;
/**
 * 相关链接：资讯
 * @param props
 * @returns
 */
function XGLinkZX(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//so.eastmoney.com/Web/s?keyword=".concat(encodeURIComponent(props.name)) }, "\u8D44\u8BAF")));
}
exports.XGLinkZX = XGLinkZX;
/**
 * 基金相关链接：估算图-基金吧-档案
 * @param props
 * @returns
 */
function XGLinkJJ(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//fund.eastmoney.com/".concat(props.code, ".html") }, "\u4F30\u503C\u56FE"),
        "\u00A0",
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,of".concat(props.code, ".html") }, "\u57FA\u91D1\u5427"),
        "\u00A0",
        react_1.default.createElement("a", { href: "//fund.eastmoney.com/f10/".concat(props.code, ".html") }, "\u6863\u6848")));
}
exports.XGLinkJJ = XGLinkJJ;
/**
 * 相关链接：通用a股股吧
 * @returns
 */
function XGLinkGB(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(props.code, ".html") }, "\u80A1\u5427")));
}
exports.XGLinkGB = XGLinkGB;
/**
 * AH用a股股吧
 * @returns
 */
function AHXGLinkGB(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(props.code, ".html") }, "A\u80A1\u5427")));
}
exports.AHXGLinkGB = AHXGLinkGB;
/**
 * 相关链接：港股吧
 * @param props
 * @returns
 */
function XGLinkGBHK(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,hk".concat(props.code, ".html") }, "\u6E2F\u80A1\u5427")));
}
exports.XGLinkGBHK = XGLinkGBHK;
/**
 * 港股相关链接：股吧-资讯-档案
 * @param props
 * @returns
 */
function XGLinksHK(props) {
    var show_all = (props === null || props === void 0 ? void 0 : props.type) == "3" || (props === null || props === void 0 ? void 0 : props.type) == "4";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !show_all &&
            react_1.default.createElement("div", { className: "xglinks" },
                react_1.default.createElement("a", { href: "//so.eastmoney.com/Web/s?keyword=".concat(encodeURIComponent(props.name)) }, "\u8D44\u8BAF")),
        show_all &&
            react_1.default.createElement("div", { className: "xglinks" },
                react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,hk".concat(props.code, ".html") }, "\u80A1\u5427"),
                react_1.default.createElement("a", { href: "//so.eastmoney.com/Web/s?keyword=".concat(encodeURIComponent(props.name)) }, "\u8D44\u8BAF"),
                react_1.default.createElement("a", { href: "//emweb.securities.eastmoney.com/PC_HKF10/CoreReading/index?type=web&code=".concat(props.code, "&color=b") }, "\u6863\u6848"))));
}
exports.XGLinksHK = XGLinksHK;
